class ClinicalStudioApi {
    checkStatus(response) {
        switch (response.status) {
            case 500: //Error 500 del Servidor
                throw new Error(`${response.status} - Server Error!`);
                break;
            default:
                break;
        }
    }

    //Crear Estudio Clinico
    async createClinicalStudio(clinicalStudioJSON) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}estudiosc/create`, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            'Content-Type': 'application/json',
            body: clinicalStudioJSON
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            console.log(data);
            console.log("FUNCIONO");
            datos = data;
        }).catch((error) => {
            return null;
        });
        return datos;
    }

    //Agregar Poliza
    async addPolicy(data) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}estudiosc/add-policy`, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            'Content-Type': 'application/json',
            body: data
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            return null;
        });
        return datos;
    }

    //Ver Estudio Clinico
    async showClinicalStudio(id_estudio) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}estudiosc/show/` + id_estudio, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            'Content-Type': 'application/json'
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos =
            {
                existe: false,
                contenido: null
            }
        });
        return datos;
    }

    //Eliminar Poliza
    async deletePolicy(dataPolicy) {
        console.log(dataPolicy);
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}estudiosc/delete-policy`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataPolicy)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos =
            {
                existe: false,
                contenido: null
            }
        });
        return datos;
    }

    //Actualizar Estudio Clinico
    async updateClinicalStudio(clinicalStudioJSON) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}estudiosc/update`, {
            method: 'PUT',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            'Content-Type': 'application/json',
            body: clinicalStudioJSON
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            console.log(data);
            console.log("FUNCIONO");
            datos = data;
        }).catch((error) => {
            return null;
        });
        return datos;
    }

    //Actualizar el Estado del Estudio Clinico
    async checkStatusClinicalStudio(id_estudio) {
        let datos;
        let dataSend = new FormData();
        dataSend.append("id_estudio",id_estudio);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}estudiosc/revisar-estado`, {
            method: 'PUT',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataSend
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            console.log(data);
        }).catch((error) => {
            throw new Error(`Error revisando el estado del estudio`);
        });
        return datos;
    }

}

export default new ClinicalStudioApi();